import React from 'react'
import PropTypes from 'prop-types'

import classNames from 'classnames'

import styles from './Round.scss'

const Round = ({ children, post }) => {

    const className = classNames(
        styles.round,
        {
            [styles.post] : post
        }
    )

    return (
        <span className={ className }>
            { children }
        </span>
    )
}

Round.propTypes = {
}


export default Round